/**
 * Manually derived from: https://shopify.dev/api/admin/rest/reference/orders/refund
 * API Version: 2022-01
 */

import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyDutyKey,
  ShopifyRefundDutyKey,
  ShopifyRefundDutyToDutyKey,
  ShopifyRefundDutyToRefundKey,
  ShopifyRefundDutyToShopKey,
  ShopifyRefundKey,
  ShopifyShopKey,
} from "./keys";
import type { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyRefundDutyKey,
  "2022-01": {
    name: "Shopify Refund Duty",
    fields: [
      {
        name: "Refund",
        fieldType: FieldType.BelongsTo,
        key: ShopifyRefundDutyToRefundKey,
        configuration: {
          relatedModelKey: ShopifyRefundKey,
        },
      },
      {
        name: "Original Duty",
        fieldType: FieldType.BelongsTo,
        key: ShopifyRefundDutyToDutyKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "duty_id" } },
        configuration: {
          relatedModelKey: ShopifyDutyKey,
        },
      },
      {
        name: "Amount Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "amount_set" } },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyRefundDutyToShopKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" } },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: { type: "rest_list", resource: "order" },
  },
  "2025-04": {
    fields: [
      {
        name: "Refund",
        fieldType: FieldType.BelongsTo,
        key: ShopifyRefundDutyToRefundKey,
        configuration: {
          relatedModelKey: ShopifyRefundKey,
        },
      },
      {
        name: "Original Duty",
        fieldType: FieldType.BelongsTo,
        key: ShopifyRefundDutyToDutyKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "duty_id", graphQLFieldKey: "originalDuty", graphQLSelection: "id" },
        },
        configuration: {
          relatedModelKey: ShopifyDutyKey,
        },
      },
      {
        name: "Amount Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "amount_set", graphQLFieldKey: "amountSet" } },
      },
    ],
    syncConfig: {
      // Synced as part of ShopifyRefund
      type: "inherit",
    },
  },
};

export const ShopifyRefundDuty = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
